import "assets/css/style.css";
import "assets/css/slick.css";
import "assets/css/commom.css";
import "assets/css/slick-theme.css";
import "assets/css/jquery.modal.css";

import "common/slick";
import "common/jQuery";
import "common/slick.1.9.0";
import "common/jquery.modal"

import React from "react";
import getRoutes from 'routes/Routes';
import Layout from "components/Layout/Index"
import NotFound from "pages/Utility/NotFound"
import { Routes, Route } from 'react-router-dom';

export default function App() {
  // 경로 지정
  const useRoute = getRoutes();

  return (
    <Routes>
      {useRoute.map((route, idx) => (
        <Route
          path={route.path}
          element={<Layout>{route.component}</Layout>}
          key={idx}
          exact={true}
        />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
